module.exports = __webpack_public_path__ + "static/img/game10.66b527a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/home/game10.jpg
// module id = oPTg
// module chunks = 1